import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMenu,{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({staticClass:"pointer",style:({
          opacity: (_vm.isLoading)?0.5:1
        }),attrs:{"title":_vm.lang(_vm.$store, `sap/listings.global.filter.order_statuses.${_vm.value}`)}},_vm.isLoading || _vm.disabled?false:on),[_vm._v("\n      "+_vm._s(_vm.itemIcon(_vm.value)?_vm.itemIcon(_vm.value):'?')+"\n    ")])]}}])},[_c(VList,_vm._l((_vm.items),function(item,key){return _c(VListItem,{key:key,on:{"click":function($event){return _vm.updateValue(key)}}},[_c(VListItemTitle,{attrs:{"title":item.title}},[_vm._v(_vm._s(item.text))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }